export const pageTypes = {
  Home: "Home",
};

// Populates the href attribute of an anchor tag to send the user to the homepage
export const homepage = "/";
